<template>

  <section class="box" :style="'background:linear-gradient(to right,'+project.color1+', '+project.color2+')'">
    <router-link to="/works" tag="span" class="boxIco boxClose">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 350 440">
          <path fill="#fff" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
        </svg>
    </router-link>
    <h1 class="boxTitle">{{project.title}}</h1>
    <article class="boxItem">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100"  viewBox="0 0 100 100">
        <circle style="transform-origin:25px 50px;" cx="25" cy="50" r="2" fill="none" stroke="rgba(0,0,0,.6)">
          <animateTransform  attributeName="transform" type="scale" values="0 0;2 2;0 0"  dur="1s"  repeatCount="indefinite" />
          <animate attributeName="opacity" values="0;1;1;1;0" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle style="transform-origin:50px 50px;" cx="50" cy="50" r="2" fill="none" stroke="rgba(0,0,0,.6)">
          <animateTransform  attributeName="transform" type="scale" begin="300ms" values="0 0;2 2;0 0"  dur="1s"  repeatCount="indefinite" />
            <animate attributeName="opacity" values="0;1;1;1;0" begin="300ms" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle style="transform-origin:75px 50px;" cx="75" cy="50" r="2" fill="none" stroke="rgba(0,0,0,.6)">
          <animateTransform  attributeName="transform" type="scale" begin="600ms" values="0 0;2 2;0 0"  dur="1s"  repeatCount="indefinite" />
            <animate attributeName="opacity" values="0;1;1;1;0" begin="600ms" dur="1s" repeatCount="indefinite" />
        </circle>
      </svg>

      <img @dblclick="zoom()" :class="'mxw'+project.width" alt="" title="double clique : zoom" v-bind:src="`${URL_SITE}${project.imgsrc}`">
    </article>
    <section class="boxDetails">
      <span v-for="(tag, t) in project.tags" :key="t"> {{tag}} </span>
    </section>

    <section class="boxDetails">
      <ul class="boxPalette">
        <li v-for="(color, c) in project.colors" :key="c">
          <em v-bind:style="{ 'background': color}"> {{color}} </em>
        </li>
      </ul>
    </section>

    <section class="boxDetails">{{project.resume}}</section>
    <router-link to="/works" class="boxFooter boxClose"><svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 448 512">
      <path fill="#fff" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"/>
    </svg> RETOUR</router-link>
  </section>
</template>

<script>
import router from '../router'
import {meta} from '../meta'

export default {
  name: 'Projet',
  props: ['projects'],
  data () {
    return {
      id: parseInt(this.$route.params.id),
      URL_SITE: 'https://endorfine.fr/img/',
      project: []
    }
  },
  computed: {
    projectFilter: function () {
      return this.projects.filter((p) => {
        return p.id === this.id
      })
    }
  },
  created () {
    this.project = this.projectFilter[0]
    document.addEventListener('keyup', this.escapeKeyListener)
    document.querySelector('#works').classList.add('noscroll')
    document.querySelector('.copyright').classList.add('none')

    // change meta tag
    var metaTitle = 'Projet : ' + this.project.title
    var metaDesc = 'Descriptif du projet, ' + this.project.resume
    meta(metaTitle, metaDesc)
  },
  destroyed () {
    document.removeEventListener('keyup', this.escapeKeyListener)
    document.querySelector('#works').classList.remove('noscroll')
    document.querySelector('.copyright').classList.remove('none')
  },
  methods: {
    escapeKeyListener: function (evt) {
      switch (evt.keyCode) {
        // Escape
        case 27:
          router.push({ path: `/works` })
          break
        // Left arrow
        case 37:
          /*
          if (this.project.id !== 0) {
            var prevId = this.project.id - 1
            router.push({ path: `/works/project/${prevId}` })
          }
          */
          break
        // Right arrow
        case 39:
          /*
          if (this.project.id !== 14) {
            var nextId = this.project.id + 1
            router.push({ path: `/works/project/${nextId}` })
          }
          */
          break
      }
    },
    zoom: function () {
      var url = this.URL_SITE + this.project.imgsrc
      window.location.href = url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page_Works_Project.vue